// extracted by mini-css-extract-plugin
module.exports = {"container":"LKResultContainer_container__1EraQ","titleContainer":"LKResultContainer_titleContainer__3t3Ho","title":"LKResultContainer_title__37EdU"};